<template>
<div class="chapter">
<div class="inner_page">
<div class="sgc-toc-title">Table of Contents</div>
<div class="sgc-toc-level-1">
<a href="#/Text/part0004">ONE</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/part0005">TWO</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/part0006">THREE</a>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0007" title="Link target outside of Sample">FOUR</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0008" title="Link target outside of Sample">FIVE</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0009" title="Link target outside of Sample">SIX</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0010" title="Link target outside of Sample">SEVEN</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0011" title="Link target outside of Sample">EIGHT</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0012" title="Link target outside of Sample">NINE</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0013" title="Link target outside of Sample">TEN</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0014" title="Link target outside of Sample">ELEVEN</span>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0003.vue?3c2562c4